/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-registration-form]';
const TOGGLE_CLASS_NAME = 'is-hidden';
const TOGGLE_REQUIRED_LABEL_CLASS_NAME = 'form-field__label--required';
const AUS_COUNTRY_CODE = 'AU';
const PLUGIN_NAME = 'registrationForm';
const MODULE_NAME = 'app.core/modules/registration-form';
const log = debug(MODULE_NAME);

log('registerd');

class RegistrationForm {

	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.$billingAddress = $(this.options.billingAddress);
		this.$billingAddressRegion = $(this.options.billingAddressRegion);
		this.$billingAddressRegionTextbox = $(this.options.billingAddressRegionTextbox);
		this.$billingAddressCountry = $(this.options.billingAddressCountry);

		this.$deliveryAddress = $(this.options.deliveryAddress);
		this.$deliveryAddressRegion = $(this.options.deliveryAddressRegion);
		this.$deliveryAddressRegionTextbox = $(this.options.deliveryAddressRegionTextbox);
		this.$deliveryAddressCountry = $(this.options.deliveryAddressCountry);

		this.init();
		this.watch();
		log('construct', element);

	}

	init() {
		this.deliveryRegion();
		this.billingRegion();
		this.billingRegionChange();
		this.deliveryRegionChange();
	}

	deliveryRegion() {
		var selectedCountry = this.$deliveryAddressCountry.val();
		if (selectedCountry == AUS_COUNTRY_CODE) {
			this.$deliveryAddressRegionTextbox.addClass(TOGGLE_CLASS_NAME);
			this.$deliveryAddressRegion.removeClass(TOGGLE_CLASS_NAME);
			this.deliveryRegionChange();
		}
		else {
			this.$deliveryAddressRegionTextbox.removeClass(TOGGLE_CLASS_NAME);
			this.$deliveryAddressRegion.addClass(TOGGLE_CLASS_NAME);
		}
	}

	billingRegion() {
		var selectedCountry = this.$billingAddressCountry.val();
		if (selectedCountry == AUS_COUNTRY_CODE) {
			this.$billingAddressRegionTextbox.addClass(TOGGLE_CLASS_NAME);
			this.$billingAddressRegion.removeClass(TOGGLE_CLASS_NAME);
			this.billingRegionChange();
		}
		else {
			this.$billingAddressRegionTextbox.removeClass(TOGGLE_CLASS_NAME);
			this.$billingAddressRegion.addClass(TOGGLE_CLASS_NAME);
		}
	}

	billingRegionChange() {
		var selectedValue = this.$billingAddressRegion.val();
		this.$billingAddressRegionTextbox.val(selectedValue);
	}

	deliveryRegionChange() {
		var selectedValue = this.$deliveryAddressRegion.val();
		this.$deliveryAddressRegionTextbox.val(selectedValue);
	}

	watch() {
		this.$billingAddressRegion.on('change', this.billingRegionChange.bind(this));
		this.$deliveryAddressRegion.on('change', this.deliveryRegionChange.bind(this));
		this.$billingAddressCountry.on('change', this.billingRegion.bind(this));
		this.$deliveryAddressCountry.on('change', this.deliveryRegion.bind(this));
	}

	unwatch() {
		this.$billingAddressRegion.off('change');
		this.$deliveryAddressRegion.off('change');

		log('unbound', this.$element);
	}
}

RegistrationForm.DEFAULTS = {
	billingAddress : "#billing_address",
	billingAddressRegion : '#billing_address_region',
	billingAddressRegionTextbox : '#BillingAddress_Region',
	billingAddressCountry : '#billing-country',
	deliveryAddress : "#delivery_address",
	deliveryAddressSection : "#delivery_address_section",
	deliveryAddressRegion : '#delivery_address_region',
	deliveryAddressRegionTextbox : '#DeliveryAddress_Region',
	deliveryAddressCountry : '#delivery-country',
};

plugin(PLUGIN_NAME, RegistrationForm);

export function exec () {
  $(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();

  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/registration-form/index.js